// Returns the URL only if it is an absolute http(s) URL, else null. Use it
// before putting stored or user-supplied URLs in an href, so a javascript: or
// data: value can't run in the HQ origin.
export const safeHttpUrl = (value) => {
  try {
    const url = new URL(value);
    return url.protocol === "http:" || url.protocol === "https:"
      ? url.href
      : null;
  } catch (error) {
    return null;
  }
};
